import React from "react";

import { useAppType } from "utils";

import { CTAButton, Col, Icon, LinkMoreInfo, Row, Typography } from "components";

export const EmptyStatePanel = ({
  buttonIcon = "newItem",
  button,
  dataTestId = "",
  description,
  headline,
  icons,
  infoLink,
  link = "",
  small = false,
  onClick,
}) => {
  const appType = useAppType();

  return (
    <section data-testid={dataTestId}>
      <div className="empty-state-banner">
        <Row justify="space-between" align="bottom" gutter={0}>
          <Col sm={24} md={small ? 24 : 14}>
            {icons && (
              <Row>
                <Col>
                  {icons.map((icon, i) => (
                    <Icon
                      dataTestId={`empty-state-panel-icon-${i}`}
                      iconName={icon}
                      size={appType.desktop && !small ? "xxxl" : "xl"}
                      className="white-text"
                      key={i}
                    />
                  ))}
                </Col>
              </Row>
            )}
            {headline && (
              <Row>
                <Col>
                  <Typography variant="h1" color="white" data-testid="empty-state-panel-headline">
                    {headline}
                  </Typography>
                </Col>
              </Row>
            )}
            {description && (
              <Row>
                <Col>
                  <Typography variant="paragraph-m" color="white" data-testid="empty-state-panel-description">
                    {description}
                  </Typography>
                  {infoLink && (
                    <LinkMoreInfo dataTestId="empty-state-panel-info-link" className="margin-top-100" theme="light" onClick={() => infoLink.onClick()}>
                      {infoLink.text}
                    </LinkMoreInfo>
                  )}
                </Col>
              </Row>
            )}
          </Col>
          <Col sm={0} md={small ? 0 : 2} />
          <Col sm={24} md={small ? 24 : 8} className={small ? "margin-top-200" : ""}>
            {button && <CTAButton icon={buttonIcon} dataTestId="empty-state-panel-link" text={button} url={link} onClick={onClick} />}
          </Col>
        </Row>
      </div>
    </section>
  );
};

export default EmptyStatePanel;
